import ReactGA from "react-ga";
import axios from "axios";
import apiUrlConfig from "../../src/environmentSettings";
import { makePropertiesObj } from "./helper";

const canvasTrackingId = "UA-151442294-1"; // Canvas GA Tracking ID
const demoTrackingId = "UA-151442294-2"; // Demo GA Tracking ID

export const trackPageThroughGA = (page, params) => {
	if (page !== undefined && params !== undefined) {
		ReactGA.initialize(
			[
				{
					trackingId: canvasTrackingId,
					gaOptions: {
						name: "Canvas",
						siteSpeedSampleRate: 100
					}
				},
				{
					trackingId: demoTrackingId,
					gaOptions: {
						name: "DemoCanvas",
						siteSpeedSampleRate: 100
					}
				}
			],
			{ debug: false, alwaysSendToDefaultTracker: false }
		);
		setParamsAndTrack(page, params);
	}
};

export const makeAnalyticsObj = (
	dashboardContainer,
	orgId,
	dashboardContainerId,
	dashboardId,
	dashboards
) => {
	try {
		return makePropertiesObj(dashboardContainer, orgId, dashboardContainerId, dashboardId, dashboards);
	} catch (error) {
		console.log("Could not make amplitude Object : " + error);
	}
};

export const setParamsAndTrack = (page, params) => {
	const url = window.location.href;
	let userType = "External";
	let accessToken = localStorage.getItem("$LoopBack$accessTokenId");
	params = params ? params : {};
	params.userId = localStorage.getItem("$LoopBack$currentUserId");
	try {
		axios
			.get(apiUrlConfig.apiConfig.p3fyUrl + "/users/" + params.userId, {
				headers: { Authorization: accessToken }
			})
			.then(res => res.data)
			.then(data => {
				let email = data.email;
				if (email && email.includes("uniqus")) {
					userType = "Internal";
				}
				params.userType = userType;
				ReactGA.set({
					page
				});

				const trackingId = url.includes("democanvas")
					? "DemoCanvas"
					: url.includes("canvas")
					? "Canvas"
					: "";

				ReactGA.set({ dimension1: params.userId ? params.userId : "" }, [trackingId]);
				ReactGA.ga(function(tracker) {
					tracker.set({ dimension2: tracker.get("clientId") }, [trackingId]);
				});
				ReactGA.set({ dimension3: params.userType ? params.userType : "" }, [trackingId]);
				ReactGA.set(
					{
						dimension7: params.orgId
							? params.orgId
							: params.organizationId
							? params.organizationId
							: ""
					},
					[trackingId]
				);
				if (page.includes("dashboardBuilder")) {
					ReactGA.set({ dimension4: "Canvas" }, [trackingId]);
					ReactGA.set(
						{ dimension5: params.dashboardContainerName ? params.dashboardContainerName : "" },
						[trackingId]
					);
					ReactGA.set({ dimension6: params.dashboardName ? params.dashboardName : "" }, [
						trackingId
					]);
					ReactGA.pageview(page, [trackingId]);
				} else if (page.includes("queryBuilder")) {
					ReactGA.set({ dimension4: "QueryBuilder" }, [trackingId]);
					ReactGA.set({ dimension5: params.mode ? params.mode : "" }, [trackingId]);
					ReactGA.set({ dimension6: params.queryName ? params.queryName : "" }, [trackingId]);
					ReactGA.pageview(page, [trackingId]);
				} else {
					ReactGA.set("dimension4", "Index");
				}
			});
	} catch (e) {
		console.log("Could not set the parameters : ", e);
	}
};
